import { DeviceTypeEnum } from '../types/DeviceType';
import { type ExpectedQueryParams } from '../types/PayApp';
import { globals } from './globals';
import { parseQueryParams } from './parseQueryParams';

const defaultQueryParams: Partial<ExpectedQueryParams> = {
  host: 'https://cashier.wixapps.net',
  showThankYouPage: true,
  skipUserInfoPage: false,
  deviceType: DeviceTypeEnum.desktop,
  dateNumberFormat: globals.locale,
  viewMode: 'site',
  allowManualPayment: true,
  forceSkipUserInfoPage: false,
  skipContactCreation: false,
};

const validQueryParamNames: (keyof ExpectedQueryParams)[] = [
  'host',
  'instance',
  'snapshotId',
  'showThankYouPage',
  'termsAndConditionsLink',
  'userInfo',
  'skipUserInfoPage',
  'viewMode',
  'deviceType',
  'dateNumberFormat',
  'referralInfo',
  'pbOrigin',
  'pbId',
  'sessionId',
  'allowManualPayment',
  'forceSkipUserInfoPage',
  'skipContactCreation',
];

export const getPayAppQueryParams = (): ExpectedQueryParams =>
  parseQueryParams<ExpectedQueryParams>({
    defaultQueryParams,
    validQueryParamNames,
  });
